import MsalApp from './MsalApp';

export default MsalApp;
